// src/hooks/useDrugQuery.ts

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { authApi } from '../services/authApi';
import { logger } from '../lib/logger';
import type { DrugDetail } from '../types';

export function useDrugQuery(
  drugId: string,
  options?: Omit<UseQueryOptions<DrugDetail, Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<DrugDetail, Error>({
    queryKey: ['drug', drugId],
    queryFn: async ({ signal }) => {
      logger.debug('useDrugQuery: fetching drug', { drugId });
      const data = await authApi.getDrug(parseInt(drugId), signal);
      logger.debug('useDrugQuery: success', { drugId, data });
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    ...options,
  });
}
